import { render } from "./Limiteds.vue?vue&type=template&id=4e31d734&scoped=true"
import script from "./Limiteds.vue?vue&type=script&lang=js"
export * from "./Limiteds.vue?vue&type=script&lang=js"

import "./Limiteds.vue?vue&type=style&index=0&id=4e31d734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e31d734"]])

export default __exports__